<template>
  <div>

    <Head title="Contacts" />
    <div class="mb-6 grid grid-cols-4 gap-4">
      <div class="col-span-1">
        <h1 class="mb-8 text-3xl font-bold">Contacts</h1>
      </div>
      <div class="col-span-3">
        <CallingNote v-if="calling" :contactId="callingId" :auth="auth" />
      </div>
    </div>
    <div class="flex items-center justify-between mb-6">
      <div class="hidden md:block flex">
        <button v-if="!calling && selected.length" id="dialerStart"
          class="rounded-md border-green-800 ring-2 ring-green-800 bg-white p-4 h-12 text-center align-middle text-green-800 font-small text-s hover:bg-green-800 hover:text-white"
          @click="callingToggle()"><i class="far fa-play-circle" /></button>
        <button v-if="calling" id="dialerStart"
          class="rounded-md border-red-500 ring-2 ring-red-500 bg-white p-4 h-12 text-center align-middle text-red-500 font-medium text-s hover:bg-red-500 hover:text-white"
          @click="callingToggle()"><i class="far fa-stop-circle" /></button>
        <EmailMass v-if="selected.length" url="emailMassContact" :emailSelected="emailSelected" :auth="auth"
          :emailTemplates="emailTemplates" :totalMatchingCount="totalMatchingCount" :selectAllFromDatabase="selectAllFromDatabase" :formFilters="form"
          @update:selected="handleUpdateSelected" />
        <SmsMass v-if="selected.length" :selected="selected" url="smsMassContact" :auth="auth"
          :smsTemplates="smsTemplates" />
      </div>
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <div class="mb-4">
          <label class="block text-gray-700 font-bold">Type:</label>
          <select v-model="form.typeFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option value="Realtor">Realtor</option>
            <option value="Financial Planner">Financial Planner</option>
            <option value="Family">Family</option>
            <option value="Loan Officer">Loan Officer</option>
            <option value="Account Executive">Account Executive</option>
            <option value="Title Agent">Title Agent</option>
            <option value="Insurance Agent">Insurance Agent</option>
            <option value="Attorney">Attorney</option>
          </select>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 font-bold">Tags:</label>
          <select v-model="form.tagsFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option v-for="tag in sortFunc(tags)" :key="tag" :value="tag">{{ tag }}</option>
          </select>
        </div>
        <div class="mb-4">
          <label class="block text-gray-700 font-bold">Cities:</label>
          <select v-model="form.citiesFilter" class="mt-1 w-full form-select">
            <option :value="null" />
            <option v-for="city in sortFunc(cities)" :key="city" :value="city">{{ city }}</option>
          </select>
        </div>
        <label class="block text-gray-700 font-bold">Trashed:</label>
        <select v-model="form.trashed" class="form-select mt-1 w-full">
          <option :value="null" />
          <option value="with">With Trashed</option>
          <option value="only">Only Trashed</option>
        </select>
      </search-filter>
      <Link class="btn-indigo" href="/contacts/create">
      <span><i class="fas fa-plus" /> Create </span>
      <span class="hidden md:inline">Contact</span>
      </Link>
    </div>
    <div class="w-full bg-white rounded-md shoadow mb-10">
      <GoogleMapsContacts :contacts="contacts" />
    </div>
    <div v-if="allSelected" class="bg-gray-50 p-4 mb-4 rounded-md border border-gray-200">
        <div class="flex items-center">
            <input 
                v-model="selectAllFromDatabase" 
                type="checkbox" 
                class="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 hover:cursor-pointer"
            />
            <span class="ml-2 text-sm text-gray-600">
                {{ selectAllFromDatabase ? `All ${totalMatchingCount} matching contacts selected for Mass Email.` : `${ emailSelected.length } emails selected on this page. Check box to select emails for all ${totalMatchingCount} matching contacts.` }}
            </span>
        </div>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="hidden md:block mt-2"><input v-model="allSelected" type="checkbox" class="m-2 w-5 h-5"
                @click="selectAll" /></th>
            <th class="pb-4 pt-6 px-6">Name</th>
            <th class="pb-4 pt-6 px-6">Type</th>
            <th class="pb-4 pt-6 px-6">City</th>
            <th class="pb-4 pt-6 px-6" colspan="2">Contact</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contact in contacts.data" :id="contact.id + 'row'" :ref="contact.id + 'row'" :key="contact.id"
            class="even:bg-gray-100 hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="md:border-t">
              <input v-if="(contact.phone || contact.email)" :id="contact.id + 'checkbox'" v-model="selected"
                type="checkbox" :value="contact.id" class="hidden md:block m-2 w-4 h-4" @click="select(contact.id)" />
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-indigo-500" :href="`/contacts/${contact.id}/edit`">
                <div class="flex flex-col">
                  <div v-if="contact.name" class="font-semibold text-m">
                    {{ contact.name }}
                  </div>
                  <div v-if="contact.organization" class="text-sm text-indigo-500">
                    {{ contact.organization.name }}
                  </div>
                </div>
                <icon v-if="contact.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              {{ contact.type }}
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex flex-col items-start px-6 py-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
                <div v-if="contact.address">{{ contact.address }}</div>
                <div v-if="contact.city">{{ contact.city }}</div>
              </Link>
            </td>
            <td class="border-t">
              <div class="px-3 md:p-0 flex flex-col text-sm mb-2 lg:max-w-xs">
                <div v-if="!!contact.phone" class="pt-4 pb-2"><a :id="contact.id + 'phone'"
                    :href="'tel:+' + phoneFormatted(contact.phone)"><i
                      class="fas fa-phone-alt text-green-500 text-base" /></a> <a
                    :href="'sms:+' + phoneFormatted(contact.phone)"><i
                      class="fas fa-sms text-indigo-600 mx-2 text-base" /></a> {{ phoneShow(contact.phone) }}</div>
                <div class="pb-2">{{ contact.email }}</div>
              </div>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/contacts/${contact.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="contacts.data.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No contacts found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex flex-wrap justify-between align-center">
      <div class="pb-4 mt-6">
        <label class="block text-gray-700 font-bold">Per Page:</label>
        <select v-model="form.perPageFilter" class="mt-1 form-select">
          <option :value="null" />
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="150">150</option>
          <option value="200">200</option>
          <option value="250">250</option>
          <option value="500">500</option>
        </select>
      </div>
      <pagination class="mt-6" :links="contacts.links" />
    </div>
  </div>
</template>

<script>
import { Head, Link, router } from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import EmailMass from '@/Shared/EmailMass'
import SmsMass from '@/Shared/SmsMass'
import CallingNote from '@/Shared/CallingNote'
import GoogleMapsContacts from '../../Shared/GoogleMapsContacts.vue'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
    CallingNote,
    EmailMass,
    SmsMass,
    GoogleMapsContacts,
  },
  layout: Layout,
  props: {
    filters: Object,
    contacts: Object,
    auth: Object,
    emailTemplates: Array,
    smsTemplates: Array,
    tags: Array,
    cities: Array,
    totalMatchingCount: Number,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        tagsFilter: this.filters.tagsFilter,
        typeFilter: this.filters.typeFilter,
        citiesFilter: this.filters.citiesFilter,
        perPageFilter: this.filters.perPageFilter,
      },
      calling: false,
      callingId: '',
      selected: [],
      emailSelected: [],
      allSelected: false,
      selectAllFromDatabase: false,
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        router.get('/contacts', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  mounted() {
    window.addEventListener('message', (e) => {
      // this.ringcentral(e)
      this.phoneCall(e)
    })
  },
  methods: {
    sortFunc: function (tags) {
      return tags.slice().sort(function (a, b) {
        return (a > b) ? 1 : -1
      })
    },
    selectAll: function () {
      if (!this.allSelected) {
        this.selected = [];
        this.emailSelected = [];
        
        this.contacts.data.forEach(contact => {
          if (contact.phone) {
            this.selected.push(contact.id);
          }
          if (contact.email) {
            this.emailSelected.push(contact.id);
          }
        });
      } else {
        this.selected = [];
        this.emailSelected = [];
        this.selectAllFromDatabase = false;
      }
      this.allSelected = !this.allSelected;
    },
    select: function (id) {
      // this.allSelected = false
      var selectedLead = this.contacts.data.find(item => item.id === id).id
      var found = false

      if (!this.allSelected) {
        for (var i = 0; i < this.emailSelected.length; i++) {
          if (this.emailSelected[i] === selectedLead) {
            found = true
            break
          }
          else {
            found = false
          }
        }

        if (found) {
          for (var a = 0; a < this.emailSelected.length; a++) {
            if (this.emailSelected[a] === selectedLead) {
              this.emailSelected.splice(a, 1)
            }
          }
        }
        else {
          this.emailSelected.push(selectedLead)
        }
      }
      this.allSelected = false
    },
    sleep(milliseconds) {
      const date = Date.now()
      let currentDate = null
      do {
        currentDate = Date.now()
      } while (currentDate - date < milliseconds)
    },
    callingToggle() {
      this.calling = !this.calling
      this.loop()
    },
    loop() {
      if (!this.calling) return
      if (this.selected.length === 0) {
        this.calling = false
        return
      }
      this.sleep(1000)
      document.getElementById(this.selected[0] + 'phone').click()
      document.getElementById(this.selected[0] + 'phone').focus()

      var selectedId = this.selected[0].toString().replace(/\D/g, '')
      var callingIdRow = selectedId + 'row'

      document.getElementById(callingIdRow).style.backgroundColor = 'rgb(224 242 254)'
      console.log(this.$refs[callingIdRow])

      this.callingId = this.selected[0].toString().replace(/\D/g, '')
      this.selected.shift()
    },
    phoneCall(e) {
      const data = e.data
      if (data) {
        switch (data.type) {
          case 'rc-call-end-notify':
            var reference = this.callingId + 'row'
            this.$refs[reference][0].style.backgroundColor = 'rgb(255, 255, 255)'
            // get message from widget event
            console.log('rc-call-end-notify:', data.message)
            // this.sleep(500)
            this.loop()
            break
          default:
            break
        }
      }
    },
    phoneShow: function (phone) {
      if (phone !== null) {
        phone = phone.replace(/[\s()-/+]+/gi, '')
        if (phone.startsWith(1) == true) {
          phone = phone.substring(1)
        }
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
      }
      else {
        phone = null
        return phone
      }
    },
    phoneFormatted: function (phone) {
      if (phone !== null) {
        phone = phone.replace(/[\s()-/+]+/gi, '')
        if (phone.startsWith(1) != true) {
          phone = '1' + phone
        }
        return phone
      }
      else {
        phone = null
        return phone
      }
    },
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    handleUpdateSelected(newValue) {
        this.selected = [...newValue];
        this.emailSelected = [...newValue];
        this.allSelected = false;
        this.selectAllFromDatabase = false;
    },
  },
}
</script>
